export const planets = [
  {
    id: 0,
    name: "Mercury",
    description:
      "Mercury-the smallest planet in our solar system and closest to the Sun-is only slightly larger than Earth's Moon. Mercury is the fastest planet, zipping around the Sun every 88 Earth days.",
    lengthOfYear: 88,
    moons: 0,
    distanceFromSun: 0.4,
    img: "assets/images/mercury.jpg",
  },
  {
    id: 1,
    name: "Venus",
    description:
      "Venus spins slowly in the opposite direction from most planets. A thick atmosphere traps heat in a runaway greenhouse effect, making it the hottest planet in our solar system.",
    lengthOfYear: 225,
    moons: 0,
    distanceFromSun: 0.7,
    img: "assets/images/venus.png",
  },
  {
    id: 2,
    name: "Earth",
    description:
      "Earth-our home planet-is the only place we know of so far that's inhabited by living things. It's also the only planet in our solar system with liquid water on the surface.",
    lengthOfYear: 365.25,
    moons: 1,
    distanceFromSun: 1,
    img: "assets/images/earth.jpg",
  },
  {
    id: 3,
    name: "Mars",
    description:
      "Mars is a dusty, cold, desert world with a very thin atmosphere. There is strong evidence Mars was-billions of years ago-wetter and warmer, with a thicker atmosphere.",
    lengthOfYear: 686.67,
    moons: 2,
    distanceFromSun: 1.5,
    img: "assets/images/mars.jpg",
  },
  {
    id: 4,
    name: "Jupiter",
    description:
      "Jupiter is more than twice as massive than the other planets of our solar system combined. The giant planet's Great Red spot is a centuries-old storm bigger than Earth.",
    lengthOfYear: 4331.865,
    moons: 79,
    distanceFromSun: 5.2,
    img: "assets/images/jupiter.jpg",
  },
  {
    id: 5,
    name: "Saturn",
    description:
      "Adorned with a dazzling, complex system of icy rings, Saturn is unique in our solar system. The other giant planets have rings, but none are as spectacular as Saturn's.",
    lengthOfYear: 10756.6125,
    moons: 62,
    distanceFromSun: 9.5,
    img: "assets/images/saturn.jpg",
  },
  {
    id: 6,
    name: "Uranus",
    description:
      "Uranus-seventh planet from the Sun-rotates at a nearly 90-degree angle from the plane of its orbit. This unique tilt makes Uranus appear to spin on its side.",
    lengthOfYear: 30681,
    moons: 27,
    distanceFromSun: 19.8,
    img: "assets/images/uranus.jpg",
  },
  {
    id: 7,
    name: "Neptune",
    description:
      "Neptune-the eighth and most distant major planet orbiting our Sun-is dark, cold and whipped by supersonic winds. It was the first planet located through mathematical calculations, rather than by telescope.",
    lengthOfYear: 60196.8525,
    moons: 14,
    distanceFromSun: 30.1,
    img: "assets/images/neptune.jpg",
  },
];
